/*** Dependencies ***/
import React, {FC} from 'react'
import cx from 'classnames'
/*** Components ***/
import Stack from '../Svg/Stack'

type props = {
  type: string,
  title: string,
  description:string,
}

const NotificationItem:FC<props> = ({type, title, description}) => {
  return  <div className={cx('d-flex align-items-center rounded p-5 mb-7',`bg-light-${type}`)}>
            <span className={cx('svg-icon me-5',`svg-icon-${type}`)}>
              <span className="svg-icon svg-icon-1">
                            <Stack />
              </span>
            </span>
            <div className="flex-grow-1 me-2">
              <div className="fw-bolder text-gray-800 text-hover-primary fs-6">{title}</div>
              <span className="text-muted fw-bold d-block">{description}</span>
            </div>
    </div>
}

export  default  NotificationItem

